"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationCallCodeForm = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _PinInput = require("../PinInput");
var _PhoneCallPinLayout = require("../PhoneCallPinLayout");
var _CountdownTimer = require("../CountdownTimer");
var _Link = require("../Link");
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ConfirmationCallCodeForm = _ref => {
  let {
    code,
    codeLength,
    submitButtonText,
    isCodeInvalid,
    isSubmitting,
    codeError,
    isResendCodeAvailable,
    codeTimeout,
    onCodeTimeoutExpired,
    codeSendTimestamp,
    onCodeChange,
    onResendCode,
    onSubmit,
    onCodeCleared
  } = _ref;
  const [isCodeCompleted, setCodeCompleted] = React.useState(false);
  const [isAutoSubmitDisabled, setAutoSubmitDisabled] = React.useState(false);
  const isTryAgain = isCodeInvalid && isCodeCompleted;
  React.useEffect(() => {
    if (isCodeInvalid) {
      setAutoSubmitDisabled(true);
    }
  }, [isCodeInvalid]);
  const handleInputSubmit = React.useCallback(() => {
    if (isSubmitting || isCodeInvalid) {
      return;
    }
    onSubmit();
  }, [isSubmitting, isCodeInvalid, onSubmit]);
  const handleButtonSubmit = React.useCallback(() => {
    if (isSubmitting) {
      return;
    }
    if (isTryAgain) {
      onCodeChange([]);
      if (onCodeCleared) {
        onCodeCleared();
      }
      return;
    }
    onSubmit();
  }, [isSubmitting, isTryAgain, onSubmit, onCodeChange, onCodeCleared]);
  const handleCodeCompletedChange = React.useCallback(isCompleted => {
    setCodeCompleted(isCompleted);
    if (isCompleted && !isSubmitting && !isAutoSubmitDisabled) {
      onSubmit();
    }
  }, [isSubmitting, isAutoSubmitDisabled, onSubmit]);
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleResendCode = React.useCallback(e => {
    e.preventDefault();
    onResendCode();
  }, [onResendCode]);
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_PhoneCallPinLayout.PhoneCallPinLayout, {
    pinInput: /*#__PURE__*/React.createElement(_PinInput.PinInput, {
      value: code,
      length: codeLength,
      invalid: isCodeInvalid,
      disabled: isSubmitting,
      onChange: onCodeChange,
      onSubmit: handleInputSubmit,
      onCompletedChange: handleCodeCompletedChange
    }),
    errorMessage: codeError
  }), /*#__PURE__*/React.createElement(_uiKit.Button, {
    "data-name": "ConfirmCodeBtn",
    theme: "fill_primary",
    loading: isSubmitting,
    disabled: !isCodeCompleted,
    fullWidth: true,
    onClick: handleButtonSubmit
  }, isTryAgain ? 'Ввести заново' : submitButtonText), /*#__PURE__*/React.createElement("div", {
    className: styles['toggle-to-sms']
  }, /*#__PURE__*/React.createElement(_Link.Link, {
    href: "#",
    onClick: handleResendCode,
    disabled: !isResendCodeAvailable
  }, "\u041C\u043D\u0435 \u043D\u0435 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B\u0438", !isResendCodeAvailable && codeSendTimestamp && codeTimeout && /*#__PURE__*/React.createElement(_CountdownTimer.CountdownTimer, {
    fromTimestamp: codeSendTimestamp,
    timeout: codeTimeout,
    onTimeoutExpired: onCodeTimeoutExpired
  }, _ref2 => {
    let {
      timeLeft
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, " (", timeLeft, " \u0441\u0435\u043A.)");
  }))));
};
exports.ConfirmationCallCodeForm = ConfirmationCallCodeForm;
ConfirmationCallCodeForm.displayName = 'ConfirmationCallCodeForm';